<template>
    <div class="loader"  style="  background-color: #E97707 !important;">
        <figure>
          <img src="https://crbox.cr/wp-content/uploads/2025/03/Orange-and-Black-Bold-Creative-Animated-Welcome-Channel-Youtube-Intro-Video-960-x-540-px.gif" alt="CrBox - Confianza Total!" style="width: 80% !important; height: auto;" />
        </figure>
    </div>
</template>

<script>
export default {
    name: 'crbox-loader',
    props: {
        width: {
            type: String,
            default: '50%'
        }
    }
}
</script>

<style>
.loader{
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1;
    visibility: visible;
}

@-webkit-keyframes breathing {
    0% {
      -webkit-transform: scale(0.85);
      transform: scale(0.85);
    }
  
    25% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  
    60% {
      -webkit-transform: scale(0.85);
      transform: scale(0.85);
    }
  
    100% {
      -webkit-transform: scale(0.85);
      transform: scale(0.85);
    }
  }
  
  @keyframes breathing {
    0% {
      -webkit-transform: scale(0.85);
      -ms-transform: scale(0.85);
      transform: scale(0.85);
    }
  
    25% {
      -webkit-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1);
    }
  
    60% {
      -webkit-transform: scale(0.85);
      -ms-transform: scale(0.85);
      transform: scale(0.85);
    }
  
    100% {
      -webkit-transform: scale(0.85);
      -ms-transform: scale(0.85);
      transform: scale(0.85);
    }
  }

.loader figure{
    display: flex;
    align-items: center;
    justify-content: center;
    /*
    -webkit-animation: breathing 1.5s ease-out infinite normal;
    animation: breathing 1.5s ease-out infinite normal;
    */
    -webkit-font-smoothing: antialiased;
}
</style>